import { render, staticRenderFns } from "./viewdetail.vue?vue&type=template&id=2d3afe57&scoped=true&"
import script from "./viewdetail.vue?vue&type=script&lang=js&"
export * from "./viewdetail.vue?vue&type=script&lang=js&"
import style0 from "./viewdetail.vue?vue&type=style&index=0&id=2d3afe57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3afe57",
  null
  
)

export default component.exports